import * as React from "react";
type Props = {
  className?: string,
};
function SvgProtein({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Protein"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1278 10.226C7.11981 13.4519 3.56741 15.4074 2.95109 18.0467C2.35916 20.662 4.68013 23.9859 6.69375 27.3098C8.73054 30.6581 10.46 34.0308 13.0887 35.131C15.7182 36.2063 19.2235 35.009 23.6056 34.2264C27.9874 33.469 33.2456 33.1267 35.5906 30.365C37.9591 27.6034 37.4383 22.4219 35.2353 18.9513C33.009 15.4566 29.1245 13.6723 25.9977 10.4707C22.8714 7.26918 20.3724 5.07506 17.9563 5.00188C15.517 4.9287 13.1363 7.00005 10.1282 10.226H10.1278Z"
        fill="#CCE0F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3081 27.6168C14.8159 28.869 15.6083 30.8005 15.6595 30.7822C16.2104 30.5813 16.8092 30.8358 16.997 31.3509C17.184 31.8652 16.8889 32.4457 16.338 32.6462C15.977 32.7775 15.9441 32.8035 15.407 32.7218C15.2294 33.008 15.0233 33.1243 14.6631 33.2556C14.1118 33.4564 13.4686 33.2157 13.3255 32.6868C13.1235 31.9388 13.9902 31.407 13.9845 31.3916C13.9825 31.3859 13.0682 28.9035 12.6226 27.6587L14.3081 27.6168ZM14.1154 25.6503C14.0175 24.7271 14.8216 24.2596 15.5627 23.0631C15.9234 22.4801 16.8283 20.821 16.5994 18.9907C16.3498 16.9893 14.8692 15.7835 14.7521 15.6912C13.1385 14.4179 10.5565 14.0764 8.71002 15.3444C6.70859 16.7181 6.65371 19.2391 6.64192 19.7656C6.59313 21.9748 8.7649 26.065 12.1209 27.4981C13.1218 27.9254 14.5074 27.7298 14.7301 27.2013C14.909 26.7797 14.2029 26.4699 14.1154 25.6503V25.6503Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9288 5.50765C13.9288 5.50765 23.7754 2.8586 27.2721 15.5481L31.2725 16.1457L27.1981 21.0011L26.0447 17.0109C26.0447 17.0109 14.1097 17.1804 13.9288 5.50765V5.50765Z"
        fill="white"
      />
      <path
        d="M19.0835 10.1313L19.967 12.2087L22.2859 9.44544L20.0072 9.02995M24.2117 11.9181C24.2117 11.9181 23.6523 13.4393 22.3144 14.1789M25.4964 12.9958C25.4964 12.9958 24.937 14.5175 23.599 15.257M27.1803 15.4668L31.1799 16.0644L27.1063 20.9202L25.9529 16.9295C25.9529 16.9295 14.0176 17.0995 13.8367 5.42674C13.8367 5.42674 23.6832 2.77728 27.1803 15.4668ZM16.4991 7.08626C16.411 7.07046 16.3285 7.03187 16.2599 6.97431C16.1913 6.91676 16.1389 6.84224 16.108 6.75818C16.0772 6.67539 16.0694 6.5858 16.0853 6.4989C16.1013 6.41201 16.1405 6.33106 16.1987 6.26463C16.2857 6.16843 16.4068 6.10997 16.5363 6.10169C16.6657 6.09342 16.7933 6.13598 16.8919 6.22032C17.1008 6.39595 17.1354 6.70207 16.9691 6.91104C16.8581 7.05089 16.678 7.11838 16.4991 7.08626Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4977 25.8035C29.4977 25.8035 28.4692 20.0021 34.4035 19.6106C34.4035 19.6106 35.4032 25.116 29.4977 25.8035V25.8035ZM19.7045 23.2626C19.7045 23.2626 25.5482 24.0399 24.1261 29.812C24.1261 29.812 18.5735 29.0961 19.7045 23.2626"
        fill="white"
      />
      <path
        d="M19.7045 23.2626C19.7045 23.2626 25.5482 24.0399 24.1261 29.812C24.1261 29.812 18.5735 29.0961 19.7045 23.2626M29.4977 25.8035C29.4977 25.8035 28.4692 20.0021 34.4035 19.6106C34.4035 19.6106 35.4032 25.116 29.4977 25.8035V25.8035Z"
        stroke="currentColor"
      />
      <path
        d="M34.4035 19.6103C28.4692 20.0018 29.4977 25.8032 29.4977 25.8032C35.4032 25.1157 34.4035 19.6103 34.4035 19.6103ZM34.4035 19.6103C34.4035 19.6103 26.5596 27.7083 25.2583 34.4667M19.7045 23.2619C19.7045 23.2619 25.5482 24.0392 24.1261 29.8113C24.1261 29.8113 18.5735 29.0954 19.7045 23.2619ZM19.7045 23.2619C19.7045 23.2619 24.8046 28.7624 25.2489 34.646"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgProtein;
